// Update add-to-cart button text with price and "1 FREE" when applicable
// Only applies to site_b2g1_pdp product pages
function runB2G1Vanilla() {
    // Check if this is a B2G1 product page
    const b2g1Page = document.querySelector("product-page.site_b2g1_pdp");
    if (!b2g1Page) return; // Exit if not a B2G1 page
  
    function updateAddToCartButtonText() {
    // Get all quantity selects
    const qtyInputs = document.querySelectorAll(".cm-variant-qty");
    if (qtyInputs.length === 0) return;

    // Calculate total price and total quantity
    let totalPriceFull = 0; // Price if all items were paid
    let totalQty = 0;
    const GLOBAL_DISCOUNT_FACTOR = window.GLOBAL_DISCOUNT_FACTOR || 1;

    // Calculate totals from variant items
    qtyInputs.forEach(function(qtyInput) {
        const qty = parseInt(qtyInput.value, 10) || 0;
        totalQty += qty;

        const itemWrapper = qtyInput.closest(".cm-variant-item");
        if (itemWrapper && qty > 0) {
        // Get price from data attribute
        const variantPriceAttr = itemWrapper.getAttribute("data-variant-price");
        if (variantPriceAttr) {
            const variantPrice = parseFloat(variantPriceAttr);
            // Apply discount factor and convert from cents to dollars
            const price = (variantPrice * GLOBAL_DISCOUNT_FACTOR) / 100;
            totalPriceFull += price * qty;
        }
        }
    });

    // Apply "Buy 2 Get 1 Free" promotion
    // For every 3 items, charge for 2 (3rd, 6th, 9th, etc. are free)
    const freeQty = Math.floor(totalQty / 3); // Number of free items
    const chargeableQty = totalQty - freeQty; // Number of items to charge for

    // Calculate average price per item
    const avgPricePerItem = totalQty > 0 ? totalPriceFull / totalQty : 0;

    // Calculate actual price to charge (chargeable quantity * average price)
    const totalPrice = chargeableQty * avgPricePerItem;

    // Get base button text (only for cm-add-to-cart buttons within multi-variant forms)
    const form = qtyInputs[0] ? qtyInputs[0].closest("form") : null;
    if (!form) return;

    const buttonTextElements = form.querySelectorAll(".cm-add-to-cart [data-js-product-add-to-cart-text]");
    if (buttonTextElements.length === 0) return;

    // Get the original button text (stored in data attribute if not already set)
    buttonTextElements.forEach(function(textEl) {
        if (!textEl.hasAttribute("data-original-text")) {
        textEl.setAttribute("data-original-text", textEl.textContent.trim());
        }
        const baseText = textEl.getAttribute("data-original-text") || "Add to cart";

        // Build new text with price
        let newText = baseText;
        if (totalQty > 0 && totalPrice > 0) {
        newText = baseText + " → $" + totalPrice.toFixed(2);
        // Add free items text if applicable
        if (freeQty > 0) {
            newText += " + " + freeQty + " FREE";
        }
        } else {
        // Reset to original text if no items selected
        newText = baseText;
        }

        textEl.textContent = newText;
    });

    // Promo label below button: show message when qty is 1 or 2
    const addToCartBtn = form.querySelector(".cm-add-to-cart");
    if (addToCartBtn) {
        let promoLabel = form.querySelector("[data-b2g1-promo-label]");
        if (!promoLabel) {
        promoLabel = document.createElement("p");
        promoLabel.setAttribute("data-b2g1-promo-label", "");
        promoLabel.className = "b2g1-promo-label";
        promoLabel.style.cssText = "margin-top: 0.5em; margin-bottom: 0; font-weight: bold; text-transform: uppercase; text-align: center;";
        addToCartBtn.parentNode.insertBefore(promoLabel, addToCartBtn.nextSibling);
        }
        if (totalQty === 1) {
        promoLabel.textContent = "Add one more bag to qualify for a free one!";
        promoLabel.style.display = "";
        } else if (totalQty === 2) {
        promoLabel.textContent = "Don't forget to add your free bag!";
        promoLabel.style.display = "";
        } else if (totalQty > 2) {
        promoLabel.textContent = "You're getting a free bag of planta!";
        promoLabel.style.display = "";
        } else {
        promoLabel.style.display = "none";
        }
    }
    }

    // ===== HPN: Preselect variant via ?preselect=VARIANT_ID, else default (first available) =====
    function preselectOrDefaultQty() {
    // Scope to B2G1 section only so we never pick up another page's form/variants
    var formEl = b2g1Page.querySelector('product-form[default-variant-id]');
    var FALLBACK_DEFAULT_VARIANT_ID = formEl ? formEl.getAttribute('default-variant-id') : null;

    var urlParams = new URLSearchParams(window.location.search);
    var paramId = urlParams.get('preselect');
    var PRESELECT_ID = (paramId && /^\d+$/.test(paramId)) ? paramId : null;

    function setQtyOneIfZeroByVariantId(variantId) {
        if (!variantId) return false;

        var item = b2g1Page.querySelector('.cm-variant-item[data-variant-id="' + variantId + '"]');
        if (!item) return false;

        var qtyEl = item.querySelector('.cm-variant-qty');
        if (!qtyEl) return false;

        var curr = parseInt(qtyEl.value, 10) || 0;
        if (curr < 1) {
        qtyEl.value = '1';
        qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var container = item.closest('.cm-variants-grid');
        if (container && container.scrollWidth > container.clientWidth) {
        var itemLeft = item.offsetLeft;
        var itemRight = item.offsetLeft + item.offsetWidth;
        var viewLeft = container.scrollLeft;
        var viewRight = container.scrollLeft + container.clientWidth;
        var nextScrollLeft = container.scrollLeft;
        if (itemLeft < viewLeft) nextScrollLeft = itemLeft;
        else if (itemRight > viewRight) nextScrollLeft = (itemRight - container.clientWidth) * 10;
        container.scrollTo({ left: nextScrollLeft, behavior: 'smooth' });
        }
        return true;
    }

    if (PRESELECT_ID && setQtyOneIfZeroByVariantId(PRESELECT_ID)) return;
    setQtyOneIfZeroByVariantId(FALLBACK_DEFAULT_VARIANT_ID);
    }

    // Sync main gallery to the variant whose qty was changed
    function syncGalleryToVariant(qtyInput) {
    var qty = parseInt(qtyInput.value, 10) || 0;
    if (qty <= 0) return;
    var item = qtyInput.closest('.cm-variant-item');
    if (!item) return;

    // Determine which variant was changed
    var variantId = item.getAttribute('data-variant-id');

    // Toggle gallery items and left thumbnails so that
    // only this variant's main + extra alternative images are visible
    if (variantId) {
        // Main gallery items
        var allGalleryItems = b2g1Page.querySelectorAll('.product-gallery-item[data-variant-id]');
        allGalleryItems.forEach(function(slide) {
        var slideVariantId = slide.getAttribute('data-variant-id');
        if (!slideVariantId || slideVariantId === variantId) {
            slide.style.display = '';
        } else {
            slide.style.display = 'none';
        }
        });

        // Left (Splide) thumbnails: reinit so Splide only sees visible slides (fixes "can't reach last thumb")
        var thumbsRoot = b2g1Page.querySelector('#thumbnail-slider');
        if (thumbsRoot) {
            reinitThumbnailsSplideForVariant(variantId);
        }
    }

    // Restore all thumb slides into the list (from hidden container + list), sort by data-index
    function restoreAllThumbSlides() {
        var list = b2g1Page.querySelector('#thumbnail-slider .splide__track .splide__list');
        var hidden = document.getElementById('b2g1-thumb-hidden-slides');
        if (!list || !hidden) return;
        var inList = list.querySelectorAll('.splide__slide');
        var inHidden = hidden.querySelectorAll('.splide__slide');
        var all = [];
        inList.forEach(function(el) { all.push(el); });
        inHidden.forEach(function(el) { all.push(el); });
        all.sort(function(a, b) {
            var ia = parseInt(a.getAttribute('data-index'), 10) || 0;
            var ib = parseInt(b.getAttribute('data-index'), 10) || 0;
            return ia - ib;
        });
        all.forEach(function(el) { list.appendChild(el); });
        hidden.innerHTML = '';
    }

    function getThumbnailsSplideOptions() {
        return {
            perPage: 5,
            fixedWidth: 80,
            fixedHeight: 80,
            gap: 10,
            pagination: false,
            direction: 'ttb',
            height: '500px',
            focus: 0,
            isNavigation: true,
            breakpoints: {
                820: { perPage: 4, height: '400px' },
                767: { direction: 'ltr', perPage: 4, height: 'auto' }
            }
        };
    }

    function reinitThumbnailsSplideForVariant(variantId) {
        var thumbsRoot = b2g1Page.querySelector('#thumbnail-slider');
        if (!thumbsRoot || typeof Splide === 'undefined') return;
        var list = thumbsRoot.querySelector('.splide__track .splide__list');
        if (!list) return;

        var hiddenId = 'b2g1-thumb-hidden-slides';
        var hidden = document.getElementById(hiddenId);
        if (!hidden) {
            hidden = document.createElement('div');
            hidden.id = hiddenId;
            hidden.setAttribute('aria-hidden', 'true');
            hidden.style.cssText = 'display:none !important;';
            thumbsRoot.parentNode.appendChild(hidden);
        }

        restoreAllThumbSlides();

        if (window._site1Thumbs) {
            try { window._site1Thumbs.destroy(); } catch (e) {}
            window._site1Thumbs = null;
        }

        var thumbSlides = list.querySelectorAll('.splide__slide');
        thumbSlides.forEach(function(thumb) {
            var vid = thumb.getAttribute('data-variant-id');
            if (vid && vid !== variantId) {
                hidden.appendChild(thumb);
            }
        });

        var options = getThumbnailsSplideOptions();
        var thumbs = new Splide('#thumbnail-slider', options);
        thumbs.on('moved', function(newIndex) {
            var activeSlide = thumbs.Components.Slides.getAt(newIndex).slide;
            var imgEl = activeSlide.querySelector('img');
            var srcEl = imgEl && (imgEl.currentSrc || imgEl.src);
            if (srcEl && window._site1ActivateMainByImgSrc) {
                window._site1ActivateMainByImgSrc(srcEl);
            }
        });
        thumbs.mount();
        window._site1Thumbs = thumbs;
        thumbs.go(0);
    }

    // Existing behavior: move main slider (and Splide) so the "primary"
    // image for this variant is focused, based on the variant card image
    var src = item.getAttribute('data-alt-img');
    if (!src) {
        var img = item.querySelector('img');
        src = img && (img.currentSrc || img.src);
    }
    if (!src) return;

    var slider = b2g1Page.querySelector('.product-gallery css-slider') || b2g1Page.querySelector('css-slider');
    if (!slider || !slider.changeSlide) return;

    var slug = src.split('/').pop().split('?')[0];
    var slides = slider.querySelectorAll('.product-gallery-item');
    var targetIndex = -1;
    for (var i = 0; i < slides.length; i++) {
        var slideImg = slides[i].querySelector('img');
        var s = (slideImg && (slideImg.currentSrc || slideImg.src)) || '';
        if (s.indexOf(slug) !== -1) {
        targetIndex = parseInt(slides[i].getAttribute('data-index'), 10);
        if (isNaN(targetIndex)) targetIndex = i;
        break;
        }
    }
    if (targetIndex >= 0 && slider.sliderEnabled) {
        slider.changeSlide(targetIndex, 'auto');
    }
    var thumbsRoot2 = b2g1Page.querySelector('#thumbnail-slider');
    if (targetIndex >= 0 && window._site1Thumbs && slug && thumbsRoot2) {
        var slideEls = thumbsRoot2.querySelectorAll('.splide__slide');
        for (var j = 0; j < slideEls.length; j++) {
        var si = slideEls[j].querySelector('img');
        if (si && (si.currentSrc || si.src).indexOf(slug) !== -1) {
            window._site1Thumbs.go(j);
            break;
        }
        }
    }
    }

    // Left (Splide) thumbnail click: main gallery and Splide are same variant order, so thumb index = slide index
    var leftThumbs = b2g1Page.querySelector('#thumbnail-slider');
    if (leftThumbs) {
    leftThumbs.addEventListener('click', function(e) {
        var slide = e.target.closest('#thumbnail-slider .splide__slide');
        if (!slide) return;
        var slider = b2g1Page.querySelector('.product-gallery css-slider') || b2g1Page.querySelector('css-slider');
        if (!slider || !slider.sliderEnabled || !slider.changeSlide) return;
        var slides = leftThumbs.querySelectorAll('.splide__slide');
        var idx = -1;
        for (var t = 0; t < slides.length; t++) {
        if (slides[t] === slide) { idx = t; break; }
        }
        if (idx >= 0) slider.changeSlide(idx, 'auto');
    });
    }

    // Listen for quantity changes (scope to B2G1 section): update button text + sync gallery
    b2g1Page.querySelectorAll(".cm-variant-qty").forEach(function(qtyInput) {
    qtyInput.addEventListener("change", function() {
        updateAddToCartButtonText();
        syncGalleryToVariant(qtyInput);
    });
    });

    // Run preselect immediately and after a short delay (section DOM may appear slightly later)
    preselectOrDefaultQty();
    setTimeout(function() {
    preselectOrDefaultQty();
    // After default variant is set, sync gallery to first variant with qty > 0 (delay so css-slider has time to init)
    var qtyInputs = b2g1Page.querySelectorAll('.cm-variant-qty');
    for (var i = 0; i < qtyInputs.length; i++) {
        if (parseInt(qtyInputs[i].value, 10) > 0) {
        syncGalleryToVariant(qtyInputs[i]);
        break;
        }
    }
    }, 150);
    setTimeout(function() {
    var qtyInputs = b2g1Page.querySelectorAll('.cm-variant-qty');
    for (var j = 0; j < qtyInputs.length; j++) {
        if (parseInt(qtyInputs[j].value, 10) > 0) {
        syncGalleryToVariant(qtyInputs[j]);
        break;
        }
    }
    }, 400);
    setTimeout(updateAddToCartButtonText, 450);
}
  
// Run when DOM is ready (deferred scripts run after parse, so DOMContentLoaded may have already fired)
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runB2G1Vanilla);
} else {
    runB2G1Vanilla();
}

console.log("site1_script_vanilla.js loaded");